import { render, staticRenderFns } from "./CustomersSegmentsFilterRFM.vue?vue&type=template&id=2d247817&scoped=true&"
import script from "./CustomersSegmentsFilterRFM.vue?vue&type=script&lang=js&"
export * from "./CustomersSegmentsFilterRFM.vue?vue&type=script&lang=js&"
import style0 from "./CustomersSegmentsFilterRFM.vue?vue&type=style&index=0&id=2d247817&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d247817",
  null
  
)

export default component.exports